import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

const Themes = () => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("xs"));
  const isSm = useMediaQuery(theme.breakpoints.between("sm", "xs"));
  const isMd = useMediaQuery(theme.breakpoints.between("md", "sm"));
  const isLg = useMediaQuery(theme.breakpoints.between("lg", "md"));
  const isXl = useMediaQuery(theme.breakpoints.up("xl"));
  let drawerWidth = "600px";
  if (isXs || window.innerWidth < 1000) {
    drawerWidth = "250px"; 
  } else if (isSm) {
    drawerWidth = "300px"; 
  } else if (isMd) {
    drawerWidth = "400px";
  } else if (isLg) {
    drawerWidth = "600px"; 
  } else if (isXl) {
    drawerWidth = "600px"; 
  }
  
  return { drawerWidth, isXs, isSm, isMd, isLg, isXl };
};

export default Themes;
